import React, { useContext, useEffect, useState } from 'react'
import { Fragment } from 'react';
import { AuthContext } from '../../../App/App';
import { HelpdeskContext } from './Helpdesk';
import axios from 'axios';
import swal from 'sweetalert'

function FilterHeader() {
    const { stateAuth, dispatchAuth } = useContext(AuthContext);
    const { stateHelpdesk, dispatchHelpdesk } = useContext(HelpdeskContext);

    const handleFilterChange = (event) => {
        dispatchHelpdesk({
            type: "CHATS",
            payload: [],
        })
        setfetch({ ...fetch, status: false, row: 0 })
        dispatchHelpdesk({
            type: "FILTER",
            filter: event.target.value,
            filterSub: null,
            endpoint: `/api/v1/helpdesk/helpdesk/chats/client/${event.target.value}`,
        })
        dispatchHelpdesk({
            type: "ACTIVE",
            active: null,
        })
    }
    const handleFilterSubCategoryChange = (event) => {
        if (event.target.value != "") {
            setfetch({ ...fetch, status: false, row: 0 })
            dispatchHelpdesk({
                type: "FILTER",
                filter: stateHelpdesk.filter,
                filterSub: event.target.value,
                endpoint: `/api/v1/helpdesk/helpdesk/chats/client/${event.target.value}`
            })

            dispatchHelpdesk({
                type: "ACTIVE",
                active: null,
            })

            dispatchHelpdesk({
                type: "TRIGGER",
                trigger: { message: "reload-chats" }
            })
        } else {
            dispatchHelpdesk({
                type: "TRIGGER",
                trigger: { message: "get-chat-category" }
            })
        }
    }

    const initialState = ({
        render: (
            <div className="form-group col-6">
                <select name="filter" className="form-control form-select ml-0 mr-sm-2" style={{ "width": "100%" }} onChange={handleFilterChange}>
                    <option value="all" defaultValue>All Message</option>
                    <option value="status">Status</option>
                    <option value="own">Ownership</option>
                </select>
            </div>
        ),
        // firstload: true,
        tempFilter: 'all',
    })

    const [renderFilter, setrenderFilter] = useState(initialState)
    const [renderFilterSubCategory, setrenderFilterSubCategory] = useState(<Fragment />)
    useEffect(() => {
        if (stateHelpdesk.filter == 'all') {
            setrenderFilterSubCategory(<Fragment />)
            fetchMoreData()
        } else {
            const own = [
                { value: "mine", name: "Mine" },
                { value: "other", name: "Other" }
            ]
            const status = [
                { value: "new", name: "New Message" },
                { value: "panding", name: "Panding" },
                { value: "process", name: "Process" },
            ]

            let type = null;
            if (stateHelpdesk.filter == 'own') type = own
            else if (stateHelpdesk.filter == 'status') type = status

            setrenderFilterSubCategory(
                <div className="form-group col-6">
                    <select name="filter" className="form-control form-select ml-0 mr-sm-2" style={{ "width": "100%" }} onChange={handleFilterSubCategoryChange}>
                        <option value="" defaultValue >Choose Category</option>
                        {type ? (type.map(op => (<option key={op.value} value={op.value}>{op.name}</option>))) : <Fragment />}
                    </select>
                </div>
            )

            dispatchHelpdesk({
                type: "TRIGGER",
                trigger: { message: "get-chat-category" }
            })
        }
    }, [stateHelpdesk.filter])

    useEffect(() => {
        if (stateHelpdesk.trigger.message == 'reload-chats') {
            fetchMoreData()
        }
    }, [stateHelpdesk.trigger])

    const [fetch, setfetch] = useState({ status: false, row: 0 })
    const fetchMoreData = () => {
        if (fetch.status != null) {
            setfetch({ ...fetch, status: true })
            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'x-access-token': localStorage.getItem('token-helpdesk-umy')
                }
            }
            axios.get(`${stateHelpdesk.endpoint}/${fetch.row}`, config)
                .then(res => {
                    setfetch({ ...fetch, status: res.data.data.length < 20 ? null : false, row: res.data.data.length < 20 ? 0 : fetch.row + 20 })
                    //chek is same category filter
                    const sameFilter = stateHelpdesk.filterSub == null ? (stateHelpdesk.filter == renderFilter.tempFilter ? true : false) : (stateHelpdesk.filterSub == renderFilter.tempFilter) ? true : false
                    let cleanChats = sameFilter ? stateHelpdesk.chats.concat(res.data.data) : res.data.data
                    //delete duplicate
                    let sameID = {}
                    cleanChats = cleanChats.filter(function (currentObject) {
                        if (currentObject.complaint_id in sameID) {
                            return false
                        } else {
                            sameID[currentObject.complaint_id] = true;
                            return true
                        }
                    })
                    //sort
                    cleanChats = cleanChats.sort((a, b) => b.time.localeCompare(a.time))
                    dispatchHelpdesk({
                        type: "CHATS",
                        payload: cleanChats,
                    })

                    dispatchHelpdesk({
                        type: "TRIGGER",
                        trigger: { message: null }
                    })

                    setrenderFilter({
                        ...renderFilter,
                        // firstload: false,
                        tempFilter: stateHelpdesk.filterSub == null ? stateHelpdesk.filter : stateHelpdesk.filterSub
                    })
                })
                .catch(err => {
                    setfetch({ ...fetch, status: false })
                    dispatchHelpdesk({
                        type: "TRIGGER",
                        trigger: { message: null }
                    })

                    if (!err.response || err.code === 'ECONNABORTED') {
                        swal("Error!", "Check Your Internet Connection!", "error", {
                            button: "OK",
                        });
                    } else if (err.response) {
                        if (err.response.data.status === 'jwt' && err.response.data.message === `TokenExpiredError`) {
                            dispatchAuth({
                                type: "LOGOUT",
                                message: 'Token expired, please login again!!!'
                            })
                        } else if (err.response.data.message) {
                            swal("Error!", `${JSON.stringify(err.response.data.message)}`, "error", {
                                button: "OK",
                            });
                        }
                    }
                })
        }
    }

    return (
        <div className="form-row mt-2 ml-2 p-0 col-12 ">
            <div className="form-group mt-4 mb-0 mr-0 ml-2 p-0 col-1">
                <small className="mr-0 ml-0 sm-2"><b>Filter</b></small>
            </div>
            <div className="form-group mt-2 mb-0 mr-0 ml-0 col-10">
                <div className="form-row m-0 p-1 col-12">
                    {renderFilter.render}
                    {renderFilterSubCategory}
                </div>
            </div>
        </div>
    )
}

export default FilterHeader
